<template>
    <div data-component="radio" class="tiw__radio_list_skeleton">
        <div v-for="n in count" :key="n" class="tiw__skeleton_item">
            <div class="tiw__skeleton_radio"></div>
            <div class="tiw__skeleton_text"></div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: "RadioSkeleton",
};
</script>

<script setup lang="ts">
const { count } = defineProps<{ count: number }>();
</script>

<style src="./radio.scss"></style>
